import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

export interface Lesson {
  id: number;
  title: string;
  description: string;
  content_text?: string | null;
  content_type: "article" | "course" | "video" | "audio";
  youtube_url?: string;
  duration?: string;
  image?: string;
}

interface ArticleReaderProps {
  lesson: Lesson;
}

export default function ArticleReader({ lesson }: ArticleReaderProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        bgcolor: colors.primary[900],
        borderRadius: 3,
        p: 2,
      }}
    >
      {/* Article Content */}
      <Box
        sx={{
          maxHeight: 500,
          overflowY: "auto",
          backgroundColor: colors.primary[800],
          borderRadius: 3,
          p: 2,
          "&::-webkit-scrollbar": {
            width: 8,
          },
          "&::-webkit-scrollbar-track": {
            bgcolor: "action.hover",
            borderRadius: 4,
          },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "#724E41",
            borderRadius: 4,
            "&:hover": {
              bgcolor: "#7a5f3d",
            },
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "1rem",
            lineHeight: 1.8,
            color: "text.primary",
            whiteSpace: "pre-line",
          }}
        >
          {lesson.content_text || lesson.description}
        </Typography>
      </Box>
    </Box>
  );
}
